module.exports = __webpack_public_path__ + "static/media/SWSCRC6-14.287920b5.mp3";